import React, { useRef, useState, useEffect } from 'react';
import { adminFetch } from '../../lib/adminFetch';

// 操作マニュアル（統計画面）を管理画面内で表示する。
// 認証付きのadmin-manual.phpを直接iframeのsrcにする（同一オリジン）。
// ※srcDoc（about:srcdoc）だと目次のページ内アンカー(#c1-1等)がスクロールしないため、実URLで表示する。
// iframeはヘッダーを付けられないので、URLには管理トークンではなく10分限りの閲覧券を付ける。
const fetchManualUrl = async () => {
  const res = await adminFetch('/api/admin-manual.php?action=ticket');
  const data = await res.json();
  return data.ticket ? `/api/admin-manual.php?doc=report&ticket=${encodeURIComponent(data.ticket)}` : '';
};

const ManualView = () => {
  const iframeRef = useRef(null);
  const [src, setSrc] = useState('');

  useEffect(() => { fetchManualUrl().then(setSrc).catch(() => {}); }, []);

  // 券は10分で切れるので、別タブは開くたびに新しい券を取る（ポップアップブロック回避のため先に窓を開く）
  const openNewTab = async () => {
    const w = window.open('', '_blank');
    const url = await fetchManualUrl().catch(() => '');
    if (w) { w.opener = null; if (url) w.location.href = url; else w.close(); }
  };
  const printManual = () => {
    const f = iframeRef.current;
    if (f && f.contentWindow) { f.contentWindow.focus(); f.contentWindow.print(); }
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
        <div>
          <h2 className="text-2xl font-bold">操作マニュアル</h2>
          <p className="text-xs text-gray-500 mt-1">統計画面（レポート機能）の操作マニュアルです。目次の項目をクリックすると該当箇所へ移動します。</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={printManual}
            className="text-sm bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50">印刷 / PDF保存</button>
          <button onClick={openNewTab}
            className="text-sm bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700">別タブで開く</button>
        </div>
      </div>

      <iframe ref={iframeRef} title="操作マニュアル" src={src || 'about:blank'}
        className="flex-1 w-full bg-white rounded-xl shadow border border-gray-200"
        style={{ minHeight: '78vh' }} />
    </div>
  );
};

export default ManualView;
